angular
  .module("censimentoFornitore.components", [])
  .component("censimentoFornitore", {
    templateUrl:
      "ng/components/censimentoAnagFornitore/censimentoFornitore.view.html",
    controllerAs: "censimentoFornCtrl",
    bindings: {
      configObj: "<",
    },
    controller: function (
      $cervedService,
      $transactionFactory,
      $userService,
      $rootScope
    ) {
      var self = this;

      self.$onInit = function () {
        self.appCustomerUser = {
          identifier: null,
          identifierType: "cf",
        };
      };

      self.isCustomerCensus = function () {
        self.loading = true;
        $userService
          .isCustomerSubjectToCensus(self.appCustomerUser)
          .then(function (response) {
            if (response.success) {
              createCensus(self.appCustomerUser.identifier);
            } else {
              self.loading = false;
            }
          })
          .catch(function (err) {
            self.loading = false;
            $rootScope.$broadcast("addAlert", {
              text: "LBL_QBEI_UNEXPECTED",
            });
            console.log(err);
          });
      };

      var createCensus = function (cf) {
        $cervedService
          .getCustomer(cf)
          .then(function (response) {
            if (response.success) {
              $transactionFactory.set(
                response.appCustomerUser.metadata.riUserG
              );
            } else {
              $transactionFactory.set(cf);
            }
            self.loading = false;
            self.configObj.viewIndex = "3";
          })
          .catch(function (err) {
            self.loading = false;
            console.log(err);
          });
      };
    },
  });
